import { Expose } from 'class-transformer';
import { DropdownModel } from 'src/app/core/data/model';


interface IAppDropdown {
  name?: string;
  value?: any;
}

export class AppDropdown extends DropdownModel {
  @Expose() name: string = 'N/A';
  @Expose() value: any;

  constructor(options?: IAppDropdown) {
    super();
    if (options) {
      if (options.name) {
        this.name = options.name;
      }
      if (options.value) {
        this.value = options.value;
      }
    }
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): any {
    return this.value;
  }
}
